export default "__VITE_ASSET__Bb7pJh1N__"